import { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { CurrencySymbol, WorkOrderStatusType } from "../../../utils/enum";
import EditCompanyExpensesModal from "../components/EditCompanyExpensesModal";

const CompanyExpenses = ({ companyExpenses = [], currency, status, hasUpdateAccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const totalExpenseCost = companyExpenses.reduce(
    (sum, exp) => sum + (parseFloat(exp.amount) || 0),
    0,
  );

  const canEdit = ![WorkOrderStatusType.CANCELLED, WorkOrderStatusType.PAID].includes(status);

  return (
    <BaseCard
      className="pt-4 pb-6 xl:px-56 md:px-16 px-5 rounded-lg !mb-[0px]"
      elevation={1}
    >
      <div className="border-bottom mb-4 flex items-center justify-between pb-1">
        <div className="flex items-center pb-1">
          <h6 className="!text-primary">Techdomain Expenses</h6>
          {canEdit && hasUpdateAccess && (
            <i
              className="fa-light fa-pencil text-gray-900 text-base ml-3 cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            ></i>
          )}
        </div>
        {companyExpenses.length > 0 && (
          <h6 className="text-primary font-medium">
            {CurrencySymbol[currency] || ""} {totalExpenseCost.toFixed(2)}
          </h6>
        )}
      </div>

      {companyExpenses.length > 0 ? (
        <section>
          {companyExpenses.map((expense) => (
            <CompanyExpenseItem key={expense.id} expense={expense} currency={currency} />
          ))}
        </section>
      ) : (
        <p className="text-gray-400 text-sm mt-2">No expenses added.</p>
      )}

      {isModalOpen && (
        <EditCompanyExpensesModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          companyExpenses={companyExpenses}
          currency={currency}
        />
      )}
    </BaseCard>
  );
};

function CompanyExpenseItem({ expense, currency }) {
  return (
    <div className="flex items-center mt-4 justify-between">
      <p className="font-normal mr-2 normal-case">
        {expense.attachment?.url && (
          <a
            href={expense.attachment.url}
            download={expense.attachment.fileName}
            target="_blank"
            rel="noopener noreferrer"
            title={expense.attachment.fileName}
            className="hover:underline mr-1"
          >
            <i className="fa-solid fa-paperclip" style={{ color: "#0F40AE" }}></i>
          </a>
        )}
        <span>
          {expense.expenseType === "TOOLS"
            ? "Tools"
            : expense.expenseType === "MATERIAL"
              ? "Material"
              : expense.expenseType === "TRAVEL"
                ? "Travel"
                : expense.expenseType === "ALL"
                  ? "All"
                  : "Other"}
        </span>{" "}
        Expense{expense.description?.trim() ? ` (${expense.description})` : ""}
      </p>
      <div className="border-t border-dotted border-gray-500 flex-grow"></div>
      <div className="bg-[#F6F6F6] inline-flex items-center ml-2 px-2 py-1 rounded-md whitespace-nowrap">
        <p className="font-normal">
          {CurrencySymbol[currency] || ""} {parseFloat(expense.amount || 0).toFixed(2)}
        </p>
      </div>
    </div>
  );
}

export default CompanyExpenses;
